export const cloudDevices = require("./shells_browser2-fs8.png");
